import {
  PublicAssetFrontendApi$AssetComponentDtoKey,
  PublicAssetFrontendApi$AssetComponentDto,
} from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import RegisterProductUiButton from "@/custolink-views/asset_frontend/ui/components/RegisterProductUiButton";
import AiSupportUiButton from "@/custolink-views/asset_frontend/ui/components/AiSupportUiButton";
import ServiceAndPartsInquiryUiButton from "@/custolink-views/asset_frontend/ui/components/ServiceAndPartsInquiryUiButton";

export default function AssetHeaderComponents(p: {
  components: Array<PublicAssetFrontendApi$AssetComponentDto>;
  onClickComponent: (
    component: PublicAssetFrontendApi$AssetComponentDto,
  ) => void;
}) {
  const aiSupComp = p.components.find(
    (s) => s.key == PublicAssetFrontendApi$AssetComponentDtoKey.AiSupport,
  );
  const regProduct = p.components.find(
    (s) => s.key == PublicAssetFrontendApi$AssetComponentDtoKey.RegisterProduct,
  );
  const service = p.components.find(
    (s) => s.key == PublicAssetFrontendApi$AssetComponentDtoKey.Inquiry,
  );

  // maintain a grid of 3, unless there only are two elements, we make a grid of two.
  // if there is only one element, we make a grid of 3, but create a fake 1st element such that the only component is centered.

  let grid = 3
  if(p.components.length > 0){
    grid = p.components.length
  }
  if(grid > 3){
    grid = 3
  }

  let insertFakeAs1st = false
  if(grid == 1){
    grid = 3
    insertFakeAs1st = true
  }

  return (
    <div className={`grid h-full grid-cols-${grid} gap-3`}>

      {
        insertFakeAs1st && <div></div>
      }

      {regProduct != null && (
        <RegisterProductUiButton
          text={regProduct.name}
          onClick={() => {
            p.onClickComponent(regProduct);
          }}
        />
      )}

      {service != null && (
        <ServiceAndPartsInquiryUiButton
          text={service.name}
          onClick={() => {
            p.onClickComponent(service);
          }}
        />
      )}

      {aiSupComp != null && (
        <AiSupportUiButton
          text={aiSupComp.name}
          onClick={() => {
            p.onClickComponent(aiSupComp);
          }}
        />
      )}
    </div>
  );
}
